module.exports = __webpack_public_path__ + "img/uf21.0eb4245a.png";